import { HelmetDexteel } from "@dexteel/mesf-core";
import { MillSetup } from "./components/MillSetup";

export const MillSetupPage = () => {
	return (
		<>
			<HelmetDexteel title="Mill Setup" />
			<MillSetup />
		</>
	);
};
